export function cn(...classes: Array<string | false | null | undefined>) {
    return classes.filter(Boolean).join(" ");
}

export function peso(amount: number) {
    return new Intl.NumberFormat("en-PH", {
        style: "currency",
        currency: "PHP",
        maximumFractionDigits: 0,
    }).format(amount);
}

export function id(prefix: string) {
    return `${prefix}-${Math.random().toString(36).slice(2, 8)}`;
}

// lib/utils.ts
export function createId(prefix: string) {
    return `${prefix}_${crypto.randomUUID()}`;
}